import { dictionariesApi } from "api/dictionaries/dictionariesApi";
import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useToaster } from "utils";

import { CreateDictionaryForm, CreateDictionaryValues } from "./DictionaryForm/CreateDictionaryForm";

export const AddDictionaryPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showSuccess } = useToaster();

  const onSubmit = (data: CreateDictionaryValues) => {
    dictionariesApi.create(data).then((x) => {
      showSuccess(`Utworzono słownik ${data.name}`);
      navigate(routes.DICTIONARIES_EDIT(x.data.id.toString()));
    });
  };

  return (
    <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
      <main className="grow">
        <CreateDictionaryForm onSubmit={onSubmit} />
      </main>
    </div>
  );
};
